import { UserNotificationFavorites } from "@api-types/notification-favorites/UserNotificationFavorites";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export class NotificationFavoritesApiService {
	static baseUrl(context: ApiRequestContextData) {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/user-match-notification-groups/user-settings`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData
	): HeadersInit => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async getNotificationFavoritesPerUser(
		options?: ContextOptions
	): Promise<UserNotificationFavorites> {
		const context = getApiRequestContext(options);
		return await httpClient.get(
			this.baseUrl(context),
			this.getRequestHeaders(context)
		);
	}

	static async updateNotificationFavorites(
		notificationFavoritesObj: UserNotificationFavorites,
		options?: ContextOptions
	) {
		const context = getApiRequestContext(options);

		return await httpClient.post(
			this.baseUrl(context),
			JSON.stringify(notificationFavoritesObj),
			this.getRequestHeaders(context)
		);
	}

	static async deleteNotificationFavorites(
		notificationFavoritesObj: UserNotificationFavorites,
		options?: ContextOptions
	) {
		const context = getApiRequestContext(options);

		return await httpClient.delete(
			this.baseUrl(context),
			this.getRequestHeaders(context),
			{
				body: JSON.stringify(notificationFavoritesObj),
			}
		);
	}
}
